<span class="text bold" *ngIf="role">{{'USER_ROLES.'+role.name.replace(" ","_").toUpperCase() | translate}}</span>